var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg010Rook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z",
    fill: "#ffe6e2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.18 18.667c-.453-1.613-.587-3.313-.387-5h-5.587c.207 1.68.073 3.387-.387 5z",
    fill: "#fc573b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.833 22.333h-9.667c-.276 0-.5-.224-.5-.5v-1c0-.643.523-1.167 1.167-1.167h8.333c.643 0 1.167.523 1.167 1.167v1c0 .276-.224.5-.5.5z",
    fill: "#fd907e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m19.5 12.667h-7c-.643 0-1.167-.523-1.167-1.167v-3c0-.276.224-.5.5-.5h1.667c.276 0 .5.224.5.5v1.167h.667v-1.167c0-.276.224-.5.5-.5h1.667c.276 0 .5.224.5.5v1.167h.666v-1.167c0-.276.224-.5.5-.5h1.667c.276 0 .5.224.5.5v3c0 .643-.524 1.167-1.167 1.167z",
    fill: "#fc573b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m22.167 24h-12.334c-.276 0-.5-.224-.5-.5v-1c0-.643.523-1.167 1.167-1.167h11c.643 0 1.167.523 1.167 1.167v1c0 .276-.224.5-.5.5z",
    fill: "#fd907e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg010Rook);
export default __webpack_public_path__ + "static/media/010-rook.dd09d6534f175ef8ca20b4f80c4a91eb.svg";
export { ForwardRef as ReactComponent };